import { useTranslation } from 'react-i18next'
import { Text, XStack } from 'tamagui'
import { useAdminPreview } from '@hooks/useAdminPreview'

/**
 * Aviso de que o produtor está vendo a área do aluno.
 *
 * Só aviso, sem link de volta: a entrada no preview é sempre o painel, numa aba
 * nova, então o caminho de volta é a aba que ficou aberta. Um link daqui para o
 * painel refazia o SSO e criava um segundo caminho para a mesma coisa.
 *
 * Vive no AppLayout de propósito: no hero_theme o banner equivalente só é
 * incluído no header e no dashboard, e a tela do player — justamente a que mais
 * confunde — fica sem aviso nenhum.
 *
 * Cores: `info-400` (azul profundo no dark, azul claro no light) com texto
 * `text-primary` (neutral-800 no default). Os dois invertem em sentidos opostos entre os temas, então o
 * contraste se mantém — 8.3:1 no dark e 10.4:1 no light, AAA nos dois. Pares
 * como `info-100`/`neutral-800` invertem juntos e somem num dos temas.
 */
export function AdminPreviewBanner() {
  const { t } = useTranslation('AdminPreview')
  const { isPreview } = useAdminPreview()

  if (!isPreview) return null

  return (
    <XStack
      testID="admin-preview-banner"
      backgroundColor="$info-400"
      paddingVertical="$size.spacing-xxs"
      paddingHorizontal="$size.spacing-xs"
      justifyContent="center"
      alignItems="center"
      flexWrap="wrap"
      gap="$size.spacing-xxs"
    >
      <Text color="$text-primary" ff="$mulishRegular" fontSize="$font-size-xxs">
        {t('banner.text')}
      </Text>
    </XStack>
  )
}
